export enum WidgetType {
  LIST = 'list',
  TABLE = 'table',
  CARD = 'card',
  CHART = 'chart',
  COUNT = 'count',
  CHIPS = 'Chips',
  DIARY = 'Diary',
  COUNT_LIST = 'COUNT_LIST',
  COUNT_GRID = 'COUNT_GRID',
  INFO_DETAIL = 'info-detail',
}

export enum WidgetID {
  PIC = 'pic',
  ESAMI_OBIETTIVI = 'esami_obiettivi',
  ALLERGIE = 'allergie',
  DIARIO = 'diario',
  DOCUMENTI = 'documenti',
  APPUNTAMENTI = 'appuntamenti',
  NOTE = 'note',
  DIAGNOSI = 'diagnosi',
  REFERENTI = 'referenti',
  SEGNALAZIONI = 'segnalazioni',
  CCT = 'cct',
  PDC = 'piano_di_cura',
  PARAMETRI = 'parametri',
  PAI = 'pai',
  CASEMANAGER = 'Case manager',
  LISTAPAZIENTI = 'listapazienti',
  ANAMNESI = 'anamnesi',
  SCALEPAZIENTE = 'scale_paziente',
  PRESCRIZIONI = 'prescrizioni',
  DOCUMENTI_DSE = 'documenti_dse',
  CONSENSI = 'consensi',
  DIARIO_CLINICO = 'diario_clinico',
  TERAPIA = 'terapia',
  ESENZIONI = 'esenzioni',
  TRASFERIMENTO_APIC = 'trasferimento_apic',
}
